export default class FetchException {
	constructor(message, additionalContext = {}) {
		this.message = message;
		this.additionalContext = additionalContext;
	}
}
